import { ConfigOptions } from '@ivicos/react-jitsi/dist/types';
import { ICallAction } from '../../CallActions';

interface CallActionHandlerProps {
    shouldRenderJitsi: boolean;
    triggerJitsiRender: boolean;
    cameraIsMuted: boolean;
    micIsMuted: boolean;
    jitsiConfig: ConfigOptions;
    setTriggerJitsiRender: (value: boolean) => void;
    setNewJitsiConfig: (config: ConfigOptions) => void;
    executeCommand: (command: string, data?: any) => void;
}

export const createCallActionHandler = ({
    shouldRenderJitsi,
    triggerJitsiRender,
    cameraIsMuted,
    micIsMuted,
    jitsiConfig,
    setTriggerJitsiRender,
    setNewJitsiConfig,
    executeCommand
}: CallActionHandlerProps) => {
    return (action: ICallAction): void => {
        if (!shouldRenderJitsi && !triggerJitsiRender && action.command && ['toggleVideo', 'toggleAudio'].includes(action.command)) {
            setTriggerJitsiRender(true);
            action.command === 'toggleVideo'
                ? setNewJitsiConfig({ ...jitsiConfig, startWithVideoMuted: false })
                : setNewJitsiConfig({ ...jitsiConfig, startWithAudioMuted: false });
            return;
        }

        if (shouldRenderJitsi && !cameraIsMuted && triggerJitsiRender && action.command === 'toggleVideo') {
            setTriggerJitsiRender(false);
        } else if (shouldRenderJitsi && !micIsMuted && triggerJitsiRender && action.command === 'toggleAudio') {
            setTriggerJitsiRender(false);
        } else if (!shouldRenderJitsi && !triggerJitsiRender && action.command && !['toggleVideo', 'toggleAudio'].includes(action.command)) {
            return;
        }

        action.command && executeCommand(action.command, action.data);
        action.onCommandSent?.();
        action.onSetTopic?.();
    };
};
